import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "online-chat-google-recaptcha" }

import {WidgetStore} from "~/chat/ts/store/Widget";
import {ConfigStore} from "~/chat/ts/store/Config";
import {useChatFormInput, useChatFormInputProps} from "~/chat/vue/widget/form/fields/useChatFormInput";
import {getCurrentInstance, onBeforeUnmount, onMounted, ref, watch} from "vue";


const __default__ = {
    name: "ChatRecaptcha"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    ...useChatFormInputProps()
},
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose, emit: __emit }) {

const HCAPTCHA_KEY = "1ea19d17-b6e0-4c24-b44f-829bdfc8e6da";
const RECAPTCHA_KEY = "6Lc1ICAUAAAAAD81Urqtpo5L0rXIKLbkx6GZ3jHo";

let props = __props;

let emits = __emit;

let recaptchaError = ref(false);

let {exposedObject} = useChatFormInput(props);

__expose(exposedObject);

let challengeFixInterval = ref<any>();

onMounted(() => {

    challengeFixInterval.value = setInterval(() => {
        let iframe = document.querySelectorAll("body > div > div > iframe[src^='https://www.google.com/recaptcha']");
        for (let i = 0; i < iframe.length; i++) {
            let div = iframe[i].parentElement.parentElement;
            if (ConfigStore.isMobile.value) {
                let className = 'online-chat-keep-visible';
                if (!div.classList.contains(className)) {
                    div.classList.add(className);
                    div.classList.add('online-chat-recaptcha-challenge');
                }
            }
            if (div) {
                div.style.zIndex = "2147483647";
            }
        }
    }, 500);

    if (!isRecaptchaReady.value) {
        let id = "online-chat-recaptcha-script";
        let script: HTMLScriptElement = document.getElementById(id) as any;
        if (!script) {
            let funcName = "onlineChatRecaptchaLoadCallback";
            let win = window as any;

            win[funcName] = () => {
                WidgetStore.SET_RECAPTCHA_READY();
                delete win[funcName];
            };
            script = document.createElement('script');
            script.id = id;
            script.async = true;
            script.defer = true;
            let languageId = ConfigStore.language.value;
            let src = `https://www.google.com/recaptcha/api.js?onload=${funcName}&render=explicit`;
            if (languageId) {
                src += `&hl=${languageId}`;
            }
            script.src = src;
            document.head.appendChild(script);
        }
    } else {
        renderRecaptcha();
    }
});

onBeforeUnmount(() => {
    clearInterval(challengeFixInterval.value);
});


function onInput(value?: string) {
    emits("update:modelValue", {value, hcaptcha: isHcaptchaUsedOnSite()});
}

let recaptcha = ref<HTMLDivElement>();
let instance = getCurrentInstance().proxy;

function renderRecaptcha() {
    let ref = recaptcha.value as HTMLDivElement;
    let grecaptcha = (window as any).grecaptcha;
    let render = grecaptcha.render;
    if (!render) {
        render = grecaptcha?.enterprise?.render;
    }
    if (typeof render == "function") {
        render(ref, {
            sitekey: isHcaptchaUsedOnSite() ? HCAPTCHA_KEY : RECAPTCHA_KEY,//"6Lc1ICAUAAAAAD81Urqtpo5L0rXIKLbkx6GZ3jHo",
            tabindex: 666,
            callback: (value: string) => {
                onInput(value);
            },
            'expired-callback': () => {
                onInput(null);
            },
            'error-callback	': () => {
                onInput(null);
            }
        });
        let recaptchaDiv = ref.childNodes[0] as HTMLDivElement;
        if (recaptchaDiv && recaptchaDiv.tagName.toLowerCase() == "div") {
            let el = instance.$el as HTMLDivElement;

            let style = recaptchaDiv.style;
            let height = parseInt(style.height);
            let width = parseInt(style.width);
            if (!isNaN(height) && !isNaN(width)) {
                let elWidth = el.offsetWidth;
                let scale: number;
                if (elWidth < width) {
                    scale = elWidth / width;
                    el.style.setProperty("height", `${height * scale}px`, "important");
                    ref.style.setProperty("transform", `scale(${scale})`, "important");
                }
                style.setProperty("width", style.width, "important");
                style.setProperty("height", style.height, "important");
            }
        }
    } else {
        recaptchaError.value = true;
    }
}

let isRecaptchaReady = WidgetStore.isRecaptchaReady;

function isHcaptchaUsedOnSite() {
    let w = (window as any);
    let hcaptcha = w.hcaptcha;
    let grecaptcha = w.grecaptcha;
    return hcaptcha && grecaptcha && grecaptcha === hcaptcha;
}

watch(isRecaptchaReady, () => renderRecaptcha());


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      ref_key: "recaptcha",
      ref: recaptcha
    }, null, 512),
    (_unref(recaptchaError))
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createTextVNode(" Ошибка отображения ReCaptcha. ")
        ], 64))
      : _createCommentVNode("", true)
  ]))
}
}

})